import { useEffect } from "react";

const UTMHandler = () => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const utm_campaign = urlParams.get("utm_campaign")
      ? decodeURIComponent(urlParams.get("utm_campaign").trim())
      : "Int2_organic"; // Default
    const utm_source = urlParams.get("utm_source")
      ? decodeURIComponent(urlParams.get("utm_source").trim())
      : "";

    console.log("UTM Campaign:", utm_campaign);
    console.log("UTM Source:", utm_source);

    let newUrl = "";

    switch (utm_campaign) {
      case "Generic_Search_SIN_3_Apr_2025":
        newUrl =
          "https://wa.me/6596659166?text=Hello%2C%20I%20have%20a%20question%20about%20one%20of%20your%20cruises";
        break;
      case "Generic_Search_2_Apr_2025":
        newUrl =
          "https://wa.me/6596659166?text=Hello%2C%20I'm%20Interested%20in%20taking%20a%20cruise%20vacation";
        break;
      case "Europe_Search_May25":
        newUrl =
          "https://wa.me/6596659166?text=Hello%2C%20I%27m%20interested%20in%20taking%20a%20cruise%20vacation%20to%20Europe";
        break;
      case "Alaska_Search_May25":
        newUrl =
          "https://wa.me/6596659166?text=Hello%2C%20I%27m%20interested%20in%20taking%20a%20cruise%20vacation%20to%20Alaska";
        break;
      case "Singapore_Search_May25":
        newUrl =
          "https://wa.me/6596659166?text=Hello%2C%20I%27m%20interested%20in%20taking%20a%20cruise%20vacation%20to%20Singapore";
        break;
      case "Caribbean_&_Bahamas_Search_May25":
        newUrl =
          "https://wa.me/6596659166?text=Hello%2C%20I%27m%20interested%20in%20taking%20a%20cruise%20vacation%20to%20the%20Caribbean%20%26%20Bahamas";
        break;
      case "Japan_Search_May25":
        newUrl =
          "https://wa.me/6596659166?text=Hello%2C%20I%27m%20interested%20in%20taking%20a%20cruise%20vacation%20to%20Japan";
        break;
      case "Middle_East_Search_May25":
        newUrl =
          "https://wa.me/6596659166?text=Hello%2C%20I%27m%20interested%20in%20taking%20a%20cruise%20vacation%20to%20the%20Middle%20East";
        break;
      case "RCI_Brand_Search_3_Apr_2025":
        newUrl =
          "https://wa.me/6596659166?text=Hello%2C%20I%20have%20a%20question%20about%20Royal%20Caribbean%20International.";
        break;
      case "Expedition_Search_May25":
        newUrl =
          "https://wa.me/6596659166?text=Hello%2C%20I%20am%20interested%20in%20taking%20an%20expedition%20cruises.";
        break;
      case "Int2Cruises_Organic":
        newUrl =
          "https://wa.me/6596659166?text=Hello%2C%20I%27m%20interested%20in%20taking%20a%20cruise%20vacation";
        break;
      default:
        newUrl = "";
        break;
    }

    console.log("Updated WhatsApp URL:", newUrl);

    function updateWhatsAppButton() {
      const waButton = document.querySelector(".wa-chat-box-content-send-btn");
      if (waButton && newUrl) {
        waButton.setAttribute("href", newUrl);
        console.log("WhatsApp link updated successfully.");
      } else {
        console.log("WhatsApp button not found, retrying...");
        setTimeout(updateWhatsAppButton, 500);
      }
    }

    updateWhatsAppButton();
  }, []);

  return null; // This component does not render anything
};

export default UTMHandler;
